// extracted by mini-css-extract-plugin
export default {"overlay":"ErrorBanner_overlay__ccG6K","banner":"ErrorBanner_banner__3AmZy","fadeInOut":"ErrorBanner_fadeInOut__BUK-J"};